export default "__VITE_ASSET__Cz1Eo$Ij__"